var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('Desktop'):_c('Mobile')}
var staticRenderFns = []

export { render, staticRenderFns }